export default "__VITE_ASSET__111f1794__"